import LocalStorageHelper from './local_storage';

const PermissionHelper = {
	isAuthenticated() {
		const crfId = LocalStorageHelper.getCrfId();
		const crfs = LocalStorageHelper.getAdminCrfs();

		return crfs.find(o => o.crf_id === crfId) !== undefined;
	}
};

export default PermissionHelper;
